import { QueryError } from '@graphql-box/helpers';

import { useQuery } from '@graphql-box/react';
import { useEffect } from 'react';
import { useToolbelt } from '#hooks/useToolbelt.ts';
import { ImageCarousel } from '../ImageCarousel/index.tsx';
import { ProfileImage } from '../ProfileImage/index.tsx';
import { formatProfiles } from './helpers/formatProfiles.ts';
import { type PersonProfilesData, type Props } from './types.ts';

const GET_PERSON_PROFILES = "\nquery GetPersonProfiles(\n  $id: ID!\n) {\n  person(id: $id) {\n    ...PersonProfiles\n  }\n}\n\nfragment PersonProfiles on Person {\n  profiles {\n    aspectRadio\n    filePath\n    fileType\n    height\n    width\n  }\n}\n";

export const ProfilesCarousel = ({ children, id, name }: Props) => {
  const { config } = useToolbelt();

  const { execute, loading, result } = useQuery<PersonProfilesData>(GET_PERSON_PROFILES, {
    loading: true,
  });

  useEffect(() => {
    void execute({ variables: { id } }, { data: { initiator: 'ProfilesCarousel' } });
    // We only want to re-execute when id changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (result instanceof QueryError) {
    console.error(result);
    return;
  }

  if (result?.errors?.length) {
    console.error(result.errors);
  }

  const profiles = formatProfiles(result?.data, config);

  if (!loading && profiles.length === 0) {
    return;
  }

  const imageCarousel = (
    <ImageCarousel images={profiles} renderImage={props => <ProfileImage name={name} {...props} />} />
  );

  return children ? children(imageCarousel) : imageCarousel;
};
